﻿

// ------------------------------------------------------------------------- //
// #START PAGE
// ------------------------------------------------------------------------- //


window.farmday = window.farmday || {};
farmday.modules = farmday.modules || {};


farmday.modules.startpage = (function () {
    var priv = {};


    /**
     * Private initialization method
     */
    priv.init = function () {
        // Internal Start page
        if ($(".js-page-identifier-startpage").length) {
            $(".customer-number").on("input",
                function (evt) {
                    if (evt.which < 48 || evt.which > 57) {
                        evt.preventDefault();
                    }

                    var tr = $(this).closest("tr");
                    var orgnr = tr.data("orgnumber");
                    var updateButton = $(".update-button[data-form-id='org_" + orgnr + "']");

                    // Hide error message if present
                    if (!tr.find(".input-err").is(":empty")) {
                        tr.find(".input-err").html("");
                        tr.css("outline", "none");
                    }

                    if ($(this).val()) {
                        updateButton.removeClass("invisible");
                    } else {
                        updateButton.addClass("invisible");
                    }
                });

            var table = $("#customer-table");
            var deleteTableRowWithAnimation = function (cellButton) {
                var row = $(cellButton).closest("tr").addClass("deleted").children("td");
                setTimeout(function () {
                    $(row)
                        .animate({ paddingTop: 0, paddingBottom: 0 }, 500)
                        .wrapInner("<div />")
                        .children()
                        .slideUp(500, function () { $(this).closest("tr").remove(); });
                },
                    1000);
            };

            $(".update-button").on("click",
                function (ev) {
                    var button = ev.target;
                    var formId = $(ev.target).data("formId");
                    var form = $("#" + formId);
                    var orgNumber = form.data("orgnumber");
                    var isActive = form.find(".active-customer").is(":checked");
                    var customerNumber = form.find(".customer-number")[0].value;
                    if ((!customerNumber || customerNumber.trim().length === 0) && isActive == true) {
                        return;
                    }

                    table.css("pointer-events", "none");
                    table.css("opacity", 0.6);

                    var tr = $("#org_" + orgNumber);
                    $.ajax({
                        type: "POST",
                        url: "/api/customer-support/update",
                        data: {
                            organizationNumber: orgNumber,
                            customerNumber: customerNumber,
                            isActive: isActive
                        },
                        success: function (xhr) {
                            table.css("pointer-events", "auto");
                            table.css("opacity", 1);

                            if (xhr.error) {
                                tr.css("outline", "thin solid #e37222");
                                tr.find(".input-err").html(xhr.error);
                                return;
                            }

                            tr.find(".input-err").html("");
                            tr.css("outline", "none");
                            deleteTableRowWithAnimation(button);
                        },
                        error: function (xhr, textStatus, errorThrown) {
                            table.css("pointer-events", "auto");
                            table.css("opacity", 1);
                            tr.find(".input-err").html("");
                            $("#error-message").css("display", "block");
                        },
                        dataType: "json"
                    });
                });

            $(".active-customer").on("change",
                function (ev) {
                    var active = $(ev.target).is(":checked");
                    var orgNumber = $(ev.target).data("orgnumber");
                    var updateButton = $(".update-button[data-form-id='org_" + orgNumber + "']");
                    var customerNumber = $("#active_" + orgNumber).find(".customer-number").val();

                    if (active) {
                        $("#inactive_" + orgNumber).css("display", "none");
                        $("#active_" + orgNumber).css("display", "block");

                        if (!customerNumber) {
                            updateButton.addClass("invisible");
                        }
                    } else {
                        $("#inactive_" + orgNumber).css("display", "block");
                        $("#active_" + orgNumber).css("display", "none");
                        updateButton.removeClass("invisible");
                    }
                });
        }
        // External Start page
        else if ($(".js-page-identifier-external-startpage").length) {
            var activeCustomerNumber = $("#ActiveCustomerNumber").val();
            var currentPageId = $("#CurrentPageId").val();
            var url = "/api/agreements/getopenagreements";

            var $agreementsBlock = $("#agreements");
            if (activeCustomerNumber.length > 0 && $agreementsBlock.length > 0) {
                $.ajax({
                    type: "POST",
                    url: url,
                    cache: false,
                    data: { activeCustomerNumber: activeCustomerNumber, currentPageId: currentPageId },
                    success: function (data) {
                        if (data.ModelString && data.ModelString.length > 0) {
                            $agreementsBlock.html(data.ModelString);
                        }
                    },
                    error: function (e) {
                        console.log("Something went wrong with the AJAX request!");
                    }
                });
            }
        }
    };


    // Initialize module
    $(function () {
        priv.init();
    });

})();
